// missingKey is not available in the context, replace mustachified occurances with an
// empty string

export const interpolateMissingKeyHTML = (html: string, missingKey: string) => {
  // check for any mustache occurences ie {{ }}
  const mustaches = html.match(/{{([\s\S]+?)}}/g);

  let newHTML = html;
  mustaches?.forEach((mustache) => {
    // replace any occurences of { }
    const stripped = mustache.replace(/{|}/g, '');
    if (stripped.startsWith(missingKey)) {
      newHTML = newHTML.replace(mustache, '');
    }
  });

  return newHTML;
};
